<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            @click="channelFilter = 'all'"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            @click="channelFilter = 'facebook'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            @click="channelFilter = 'line'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <!-- <div class="text-xs-right">
            <exportxlsx :promisedValue="getXlsxData"></exportxlsx>
          </div> -->
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter :defaultFilter="'last_7_days'" v-model="selectedDate"></date-filter>
    </div>

    <div class="mt-5">
      <LamyBehaviorReportAsked :selectedDate="selectedDate"></LamyBehaviorReportAsked>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import OverviewFilter from '@/components/view/template/lamy/PurchaseBehavior/OverviewFilter.vue'
import LamyBehaviorReportAsked from './LamyBehaviorReportAsked.vue'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    apexchart: VueApexCharts,
    OverviewFilter,
    LamyBehaviorReportAsked
  },
  data() {
    return {
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      channelFilter: 'all',
      filter: {
        app: ''
      },
      search: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getPdpaReportExport()

        resolve(
          data.map((el) => {
            var pdpaStatus
            if (el.pdpa) {
              pdpaStatus = 'ยอมรับ'
            } else {
              pdpaStatus = 'ไม่ยอมรับ'
            }

            return {
              ชื่อลูกค้า: el.name,
              เพศ: el.gender,
              อายุ: el.ages,
              วันเดือนปีเกิด: el.dob ? moment(el.dob).format('DD/MM/YYYY') : '',
              เบอร์โทรศัพท์: el.phone_number,
              อีเมล: el.email,
              วันที่สมัครสมาชิก: el.register_timestamp
                ? moment(el.register_timestamp).format('DD/MM/YYYY')
                : '',
              วันหมดอายุสมาชิก: el.expired_timestamp
                ? moment(el.expired_timestamp).format('DD/MM/YYYY')
                : '',
              วันที่ต่ออายุสมาชิก: el.renew_timestamp
                ? moment(el.renew_timestamp).format('DD/MM/YYYY')
                : '',
              การยินยอม_PDPA: pdpaStatus
            }
          })
        )
      })
    },
    getPdpaReportExport() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid, // required
          app: vm.channelFilter,
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        vm.loading = true
        api.getLamyPdpdReportExport(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.loading = false
            resolve(response.data)
          } else {
            console.error(err)
            return
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/lamy/LamyBehaviorReport.vue